import {
    ReactElement,
    useRef,
} from 'react';

import {Stack,} from '@mantine/core';

import {useCodeRepositoryList} from '../hooks/useCodeRepositoryList.ts';
import {useCodeRepositoriesFilter} from '../hooks/useCodeRepositoriesFilter.ts';

import {
    MantineDataTable,
    SimpleTableBatchAction,
    useTableSort,
    DataTableTokenPagination,
} from '@flexinet/ui-components';
import {useCodeRepositoriesSearch} from "../hooks/useCodeRepositoriesSearch.ts";
import {useCodeRepositoriesSelection} from "../hooks/useCodeRepositoriesSelection.ts";
import {useCodeRepositoriesTableColumns} from "../hooks/useCodeRepositoriesTableColumns.tsx";
import {DataTableColumn} from "mantine-datatable";

export const RecordsTable = ({
                                 extraTools,
                                 settings,
                             }: {
    extraTools?: ReactElement[],
    settings?: { label: string, onClick: () => void }[]
}) => {

    const {filters} = useCodeRepositoriesFilter();

    const {
        visibleItems: records,
        loading,
        nextToken,
        fetchNextPage,
    } = useCodeRepositoryList(filters);

    const {
        columns,
    } = useCodeRepositoriesTableColumns();

    // FNP-912. Sorts the pages LOADED SO FAR — token pagination cannot order
    // rows the browser has not fetched, which is why the footer states a
    // loaded count. `name` is immutable and non-null, so the default is
    // always meaningful.
    const {sortStatus, setSortStatus, sorted} = useTableSort(records, {
        columnAccessor: 'name',
        direction: 'asc',
    });

    const {
        keyword,
        handleFilterByKeyword,
    } = useCodeRepositoriesSearch();

    const {
        selection,
        handleRowSelection,
        handleClearSelection
    } = useCodeRepositoriesSelection();

    const selectedRecords = records.filter(record => selection[record.name]);

    const scrollViewportRef = useRef<HTMLDivElement>(null);

    return (
        <Stack>
            <SimpleTableBatchAction
                limit={10}
                handleItemsPerPageChange={() => {}}
                settings={settings}
                handleFilterByKeyword={handleFilterByKeyword}
                extraTools={extraTools}
            />

            <MantineDataTable
                columns={columns as DataTableColumn[]}
                records={sorted}
                sortStatus={sortStatus}
                onSortStatusChange={setSortStatus}
                selectedRecords={selectedRecords}
                onSelectedRecordsChange={(items) => {
                    handleClearSelection();
                    items.forEach((item: any) => {
                        handleRowSelection(item.name, true)
                    })
                }}
                fetching={loading}
                idAccessor={'name'}
                onScrollToBottom={() => fetchNextPage()}
                scrollViewportRef={scrollViewportRef}
            />

            <DataTableTokenPagination
                loadedCount={records.length}
                filterTerm={keyword}
                nextToken={nextToken}
                handleLoadMore={fetchNextPage}
            />
        </Stack>
    );
};
